import { useEffect } from 'react';

export interface Toast {
  id: string;
  text: string;
  tone: 'info' | 'ok' | 'error';
}

/** Never stack more than this — beyond three it reads as an error state. */
const MAX_VISIBLE = 3;

export function Toasts({ toasts, onExpire }: { toasts: Toast[]; onExpire: (id: string) => void }) {
  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((t) =>
      window.setTimeout(() => onExpire(t.id), t.tone === 'error' ? 6000 : 3200),
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, onExpire]);

  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.slice(-MAX_VISIBLE).map((t) => (
        <div key={t.id} className="toast" data-tone={t.tone}>
          <span className="bullet" />
          <span>{t.text}</span>
        </div>
      ))}
    </div>
  );
}
